module.exports = __webpack_public_path__ + "img/regiter-icon07-selected.4dd5e3b5.png";